import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/financial/invoicesReportActions'
import * as api from '../../../api/reports/financial/invoicesReport'

function* invoicesReportGetJobList(action) {
  try {
    const payload = yield call(api.getJobList, action.filters)
    yield put({ type: constants.INVOICES_REPORT_GET_JOB_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.INVOICES_REPORT_GET_JOB_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* invoicesReportGetOrganizationList(action) {
  try {
    const payload = yield call(api.getOrganizationList, action.filters)
    yield put({ type: constants.INVOICES_REPORT_GET_ORGANIZATION_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.INVOICES_REPORT_GET_ORGANIZATION_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* invoicesReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.INVOICES_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.INVOICES_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */
function* watchinvoicesReportGetJobList() {
  yield takeLatest(constants.INVOICES_REPORT_GET_JOB_LIST.ACTION, invoicesReportGetJobList)
}

function* watchinvoicesReportGetOrganizationList() {
  yield takeLatest(
    constants.INVOICES_REPORT_GET_ORGANIZATION_LIST.ACTION,
    invoicesReportGetOrganizationList
  )
}

function* watchinvoicesReportGetFullReport() {
  yield takeLatest(constants.INVOICES_REPORT_GET_FULL_REPORT.ACTION, invoicesReportGetFullReport)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchinvoicesReportGetJobList),
    fork(watchinvoicesReportGetOrganizationList),
    fork(watchinvoicesReportGetFullReport)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/financial/invoicesReportSaga.js